export default "__VITE_ASSET__aeb7389c__"